import React, { Component } from "react";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { getEditingProperties, setPropertiesUpdateState, updateProperties } from "../../../../../actions/userActions";
import PropertiesEditForm from "./PropertiesEditForm";
import { Button, Icon } from "@material-ui/core";
import TitledForm from "../../../../Helpers/TitledForm";
import FormView from "../../../../FormView";
import Title from "../../../../SidePanel/Title";
import LinkHelper from "../../../../Helpers/Link";
import { isEqual } from "lodash";
import { requestState, capitalize } from "../../../../../actions/utils";
import { Redirect } from "react-router-dom";
import { validatePropertiesEditor } from "../../../../../actions/validation";

const formName = "propertiesEdit";
class PropertiesEditor extends Component {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.translateValues = this.translateValues.bind(this);
        this.initialResidenceType = this.initialResidenceType.bind(this);
        this.translateResidenceType = this.translateResidenceType.bind(this);
        this.initialRange = this.initialRange.bind(this);
        this.initialArray = this.initialArray.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setValidity = this.setValidity.bind(this);
        this.state = {
            validity: undefined,
            max: 0
        }
    }

    componentDidMount() {
        this.props.getEditingProperties();
    }

    setValidity(values) {
        const validity = validatePropertiesEditor(values, this.props.landlord);
        this.setState({
            validity
        });
    }

    isValid(validity) {
        return validity !== undefined && !Object.keys(validity).length;
    }

    handleChange(values, dispatch, props, previousValues) {
        this.setValidity(values);
        if (this.props.onChange)
            this.props.onChange(values, dispatch, props, previousValues);
    }

    handleSubmit(values, dispatch, props) {
        const translatedValues = this.translateValues(values);
        // General equality checks
        Object.keys(translatedValues).forEach(key => {
            if (isEqual(translatedValues[key], this.props.properties[key])) {
                delete translatedValues[key];
            }
        });
        // Specific equality checks
        if (translatedValues.creditRating) {
            if (isEqual(translatedValues.creditRating, this.initialArray(this.props.properties, "creditRating").creditRating))
                delete translatedValues.creditRating;
        }
        if (translatedValues.view) {
            if (isEqual(translatedValues.view, this.initialView(this.props.properties.view).view))
                delete translatedValues.view;
        }
        if (translatedValues.location) {
            if (isEqual(translatedValues.location, this.translateLocation(this.props.properties.location).location))
                delete translatedValues.location;
        }

        if (this.props.landlord) {
            if (translatedValues.rentMin || translatedValues.rentMin === 0)
                translatedValues.rentMax = translatedValues.rentMin;
            if (translatedValues.sizeMin || translatedValues.sizeMin === 0)
                translatedValues.sizeMax = translatedValues.sizeMin;
        }

        console.log("NEW VALUES >>", translatedValues); // DEBUG
        this.props.updateProperties(translatedValues);
    }

    translateLocation(location) {
        if (!location)
            return {};
        return {
            location: `(${location.lat},${location.lng})`
        }
    }

    initialResidenceType(residenceType) {
        if (this.props.landlord)
            return {};
        if (!residenceType)
            return {};
        const result = {};
        let obj;
        if (Array.isArray(residenceType))
            // result.residenceType = residenceType[0];
            obj = residenceType[0];
        else if (typeof residenceType === "object") {
            // result.residenceType = residenceType;
            obj = residenceType;
        }
        if (typeof obj === "object") {
            Object.keys(obj).forEach(key => {
                if (obj[key] === true)
                    result[`residenceType${capitalize(key)}`] = true;
            });
        }
        return result;
    }

    translateResidenceType(values, key) {
        if (this.props.landlord)
            return {};
        const result = {};
        const types = [
            "office",
            "storage",
            "retail"
        ]
        for (let i = 0; i < types.length; i++) {
            if (values[`${key}${capitalize(types[i])}`])
                result[types[i]] = true;
        }
        if (!Object.keys(result).length)
            return {};
        return { [key]: [result] };
    }


    initialRange(values, key) {
        const range = {
            min: values[`${key}Min`],
            max: values[`${key}Max`]
        };
        const result = {};
        result[`${key}Min`] = (typeof range.min === 'string') ? Number(range.min) : range.min;
        result[`${key}Max`] = (typeof range.max === 'string') ? Number(range.max) : range.max;
        return result;
    }

    translateRange(values, key) {
        const range = {
            min: values[`${key}Min`],
            max: values[`${key}Max`]
        };
        const result = {};
        if (range.min === "")
            result[`${key}Min`] = null;
        if (range.max === "")
            result[`${key}Max`] = null;
        return result;
    }


    initialArray(values, key) {
        const str = values[key];
        if (!str)
            return {};
        let matches;
        if (Array.isArray(str)) {
            matches = str;
        }
        else if (typeof str === "string") {
            if (str === "{}")
                return {};
            const strRegex = /"[^"]+"/g;
            const captures = str.match(strRegex);
            if (!captures)
                matches = [str];
            else
                matches = captures.map(m => m.substring(1, m.length - 1));
        }
        if (!matches)
            return {};
        const result = {};
        result[key] = [];
        for (let i = 0; i < matches.length; i++) {
            result[key].push(matches[i]);
        }
        return result;
    }

    initialOccupation(occupation) {
        if (!occupation)
            return {};
        const result = {};
        result.occupation = [];
        if (occupation.work) {
            result.occupation.push("work");
            if (occupation.workDetails)
                result.workDetails = occupation.workDetails;
        }
        if (occupation.student) {
            result.occupation.push("student");
            if (occupation.studentDetails)
                result.studentDetails = occupation.studentDetails;
        }
        return result;
    }

    translateOccupation(occupation, workDetails, studentDetails) {
        if (!occupation)
            return {};
        if (occupation.length === 0)
            return {};
        const result = {};
        if (occupation.includes("work")) {
            result.work = true;
            if (workDetails)
                result.workDetails = workDetails;
        }
        if (occupation.includes("student")) {
            result.student = true;
            if (studentDetails)
                result.studentDetails = studentDetails;
        }
        return result;
    }

    initialChildren(children) {
        if (!children)
            return {};
        const result = {};
        result.children = children.map(c => Number(c));
        return result;
    }

    translateEmployee(children) {
        if (!children)
            return {};
        const result = {};
        result.children = children.map(c => String(c));
        return result;
    }

    initialView(view) {
        if (!view)
            return {};
        const result = {};
        if (typeof view === "string") {
            if (view === "false")
                result.view = false;
            else if (view === "true")
                result.view = true;
        }
        else if (typeof view === "boolean") {
            result.view = view;
        }
        return result;
    }

    translateView(view) {
        if (!view)
            return {};
        return { view: String(view) }
    }

    initialValues(values) {
        // console.log( "INITIAL VALUES >>", values );
        return {
            ...values,
            ...this.initialOccupation(values.occupation),
            ...this.initialChildren(values.children),
            ...this.initialArray(values, "creditRating"),
            ...this.initialRange(values, "rent"),
            ...this.initialRange(values, "size"),
            ...this.initialResidenceType(values.residenceType),
            ...this.initialView(values.view)
        }
    }

    translateValues(values) {
        const trimmedValues = {};
        Object.keys(values).forEach(key => {
            if (this.props.properties.hasOwnProperty(key)) {
                trimmedValues[key] = values[key];
            }
        });
        return {
            ...trimmedValues,
            occupation: this.translateOccupation(values.occupation, values.workDetails, values.studentDetails),
            ...this.translateEmployee(values.children),
            ...this.translateResidenceType(values, "residenceType"),
            ...this.translateLocation(values.location),
            ...this.translateRange(values, "rent"),
            ...this.translateRange(values, "size"),
            ...this.translateView(values.view)
        }
    }

    render() {
        const { landlord, manualSubmit, submitState, dispatch, properties, propertiesState } = this.props;
        if (propertiesState !== requestState.ok)
            return <div />;
        if (submitState === requestState.ok) {
            dispatch(setPropertiesUpdateState(requestState.none));
            return <Redirect to="/user/information" />;
        }
        return (
            <FormView
                content={
                    <TitledForm
                        stretch
                        titleAlign="left"
                        titleSize="wide"
                        formSize="wide"
                        formAlign="stretch"
                        title="Here you can edit your property information"
                        form={
                            <PropertiesEditForm
                                validity={this.state.validity}
                                form={formName}
                                landlord={landlord}
                                onSubmit={this.handleSubmit}
                                onChange={this.handleChange}
                                initialValues={this.initialValues(properties)}
                            />
                        }
                        header={
                            <LinkHelper to="/user/information">
                                <Button
                                    color="secondary"
                                >
                                    <Icon>arrow_back</Icon>&nbsp;Go back to the previous page
                                </Button>
                            </LinkHelper>
                        }
                        footer={
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={!this.isValid(this.state.validity)}
                                onClick={() => manualSubmit(formName)}
                            >
                                Submit
                            </Button>
                        }
                    />
                }
                sideContent={<Title />}
            />
        );
    }

}

export default connect(
    state => ({
        user: state.user.data,
        landlord: state.user.data.isLandlord,
        properties: state.user.editingProperties,
        propertiesState: state.user.editingPropertiesState,
        submitState: state.user.propertiesUpdateState
    }),
    (dispatch, ownProps) => ({
        manualSubmit: (form) => dispatch(submit(form)),
        updateProperties: (values) => dispatch(updateProperties(ownProps.propId, values)),
        getEditingProperties: () => dispatch(getEditingProperties(ownProps.propId)),
        dispatch: dispatch
    })
)(PropertiesEditor);